(function () {
  'use strict';

  var root = document.getElementById('PeekoraMiniCart');
  if (!root) return;

  var itemsEl = root.querySelector('[data-pkmc-items]');
  var emptyEl = root.querySelector('[data-pkmc-empty]');
  var loadingEl = root.querySelector('[data-pkmc-loading]');
  var footerEl = root.querySelector('[data-pkmc-footer]');
  var countEl = root.querySelector('[data-pkmc-count]');
  var regularRow = root.querySelector('[data-pkmc-regular-row]');
  var regularEl = root.querySelector('[data-pkmc-regular]');
  var savingRow = root.querySelector('[data-pkmc-saving-row]');
  var savingEl = root.querySelector('[data-pkmc-saving]');
  var subtotalEl = root.querySelector('[data-pkmc-subtotal]');
  var bodyEl = root.querySelector('.pkmc__body');
  var codeInput = root.querySelector('#pkmc-discount-code');
  var lastFocus = null;
  var currentCart = null;
  var mutating = false;
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD';
  var FR = String(document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
  var BASE = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var GIFT_SKU = 'PEEKORA-MINISCOPE-FREE-GIFT';

  /* FIX (2026-08-02): the drawer used to lock the page with nothing but
     document.body.style.overflow = 'hidden'.

     iOS Safari ignores overflow:hidden on <body> for touch scrolling. The page
     behind the drawer therefore stayed scrollable, and because the drawer's own
     item list had almost no scrollable range left, a swipe over the products
     chained straight through to the store underneath. From the customer's side
     the cart looked frozen while the page behind it slid around - reported as
     "can't scroll the products in the cart".

     position:fixed on <body> is the only lock that holds on iOS, but it drops
     the page to the top, so the offset is captured on open and restored on
     close. The active flag matters because open() runs again on every
     add-to-cart while the drawer is already open; without it the second call
     would capture y=0 from the already-fixed body and dump the shopper at the
     top of the page when they closed the cart. */
  var scrollLock = { active: false, y: 0 };

  function lockScroll() {
    if (scrollLock.active) return;
    scrollLock.y = window.pageYOffset || document.documentElement.scrollTop || 0;
    scrollLock.active = true;
    var style = document.body.style;
    style.position = 'fixed';
    style.top = -scrollLock.y + 'px';
    style.left = '0';
    style.right = '0';
    style.width = '100%';
    style.overflow = 'hidden';
  }

  function unlockScroll() {
    if (!scrollLock.active) return;
    scrollLock.active = false;
    var style = document.body.style;
    style.position = '';
    style.top = '';
    style.left = '';
    style.right = '';
    style.width = '';
    style.overflow = '';
    window.scrollTo(0, scrollLock.y);
  }

  /* ------------------------------------------------------------------------
     FIX (2026-08-02): force the wallet buttons into ONE HORIZONTAL ROW.

     The buttons were rendering as a full-width vertical stack - four buttons,
     ~230px of pinned footer, which is what buried the product list.

     This is not a styling problem and cannot be fixed in CSS: the buttons live
     in a CLOSED shadow DOM, so their internal layout is unreachable. Shopify's
     cart layout is horizontal by DEFAULT and only falls back to the vertical
     stack when the container is too narrow to fit the buttons side by side.
     The drawer was tripping that fallback because pk-commerce-brand-sync.js
     places #PkOfficialAcceleratedCheckout on DOMContentLoaded, at which point
     #PeekoraMiniCart still carries the `hidden` attribute and measures 0px
     wide. The component saw no room for a row and stacked, then never
     re-measured - brand-sync is deliberately idempotent and will not re-insert
     a block that is already in place.

     Re-attaching the block pushes Shopify's component through its
     connectedCallback again, which re-measures the container. Width is real as
     soon as `hidden` is removed - the drawer is only translated off-screen at
     that point, not collapsed - so this does not need to wait for the open
     transition to finish.

     VERIFIED, not assumed. On a cold cache the component can still be mid-boot
     when we re-attach, and would settle stacked again. So after each attempt we
     measure the block: one row of 38px buttons is well under ROW_MAX_HEIGHT,
     while a stack of four is ~170px. If it still reads as stacked we retry, up
     to MAX_ATTEMPTS. The cap matters - each detach/re-attach restarts the
     wallet buttons' measure cycle, which is the 2026-08-01 regression that
     brand-sync's placement check exists to prevent. Retrying a bounded number
     of times only while the layout is provably wrong is the compromise.
     ---------------------------------------------------------------------- */
  var ROW_MAX_HEIGHT = 90;
  var MAX_ATTEMPTS = 5;
  var walletState = { settled: false, attempts: 0, timer: null };

  function walletBlock() {
    return document.getElementById('PkOfficialAcceleratedCheckout');
  }

  function verifyWalletRow() {
    var wallets = walletBlock();
    if (!wallets) return;

    var height = wallets.offsetHeight;

    // Zero height means the block has not painted yet - not a failure, just
    // early. Keep trying without burning the attempt budget on it.
    if (height > 0 && height <= ROW_MAX_HEIGHT) {
      walletState.settled = true;
      return;
    }

    if (walletState.attempts >= MAX_ATTEMPTS) {
      // Give up cleanly. The stacked layout still works, it is just tall, and
      // the CSS hedge keeps those buttons at 38px rather than 52px.
      walletState.settled = true;
      return;
    }

    layoutWallets();
  }

  function layoutWallets() {
    if (walletState.settled) return;

    var wallets = walletBlock();
    var anchor = root.querySelector('[data-pkmc-wallet-anchor]');

    // Nothing to do until brand-sync has moved the block into the drawer.
    if (!wallets || !anchor || !root.contains(wallets)) return;

    // No point measuring against a hidden drawer - that is the original bug.
    if (root.hidden || !anchor.offsetWidth) return;

    walletState.attempts += 1;
    anchor.insertAdjacentElement('afterend', wallets);

    window.clearTimeout(walletState.timer);
    walletState.timer = window.setTimeout(verifyWalletRow, 400);
  }

  /* An orientation change or a tablet resize changes how many buttons fit, so
     let the component re-decide. Reset the budget: this is a new question, not
     a retry of the old one. */
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    if (root.hidden) return;
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      walletState.settled = false;
      walletState.attempts = 0;
      layoutWallets();
    }, 250);
  });

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
        style: 'currency',
        currency: currency
      }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return '$' + ((Number(cents) || 0) / 100).toFixed(2);
    }
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[character];
    });
  }

  function getCode() {
    return codeInput ? codeInput.value.trim().toUpperCase() : '';
  }

  function saveCode() {
    try { sessionStorage.setItem('pq-discount-code', getCode()); } catch (error) {}
  }

  function discountUrl(target) {
    return '/discount/' + encodeURIComponent(getCode()) + '?redirect=' + encodeURIComponent(target);
  }

  function lineDiscounts(item) {
    return (item.line_level_discount_allocations || []).map(function (allocation) {
      var title = allocation.discount_application && allocation.discount_application.title;
      return title ? '<span>' + escapeHtml(title) + '</span>' : '';
    }).join('');
  }

  function isGift(item) {
    var properties = item.properties || {};
    return Boolean(properties._free_gift) ||
      (item.final_line_price === 0 && String(item.product_handle || '').toLowerCase().indexOf('miniscope') !== -1);
  }

  function isOfficialScopeBundle(item) {
    var properties = item.properties || {};
    var title = String(item.product_title || '').toLowerCase();
    return String(properties._peekora_offer || '') === 'Official Shopify Fixed Bundle' || title.indexOf('2-pack') !== -1 || title.indexOf('3-pack') !== -1;
  }

  function findItem(key) {
    if (!key || !currentCart || !currentCart.items) return null;
    for (var index = 0; index < currentCart.items.length; index += 1) {
      if (currentCart.items[index].key === key) return currentCart.items[index];
    }
    return null;
  }

  /* ------------------------------------------------------------------------
     2026-10-14: CHANGE COLOUR / OPTION FROM THE CART.
     Customers could not switch a line's colour (PeekoraScope, MiniScope) or
     option (MagicReveal book, TalkReader, PrismMatch) once it was in the cart.
     Every paid line that has real options now shows its option as a pill
     button; tapping it opens chips for the product's other options.

     Shopify cannot change a line's variant in place, so a swap is:
       1. /cart/add.js    the new variant, same quantity, same properties
       2. /cart.js        look the OLD line up again (see below)
       3. /cart/change.js that line, minus the swapped quantity
     Add FIRST, remove second: the cart never dips below its tier (2+
     PeekoraScopes) mid-swap, so the gift engine never revokes the free
     MiniScope only to re-add it. One peekora:cart:changed fires at the end,
     so pk-offer-eligibility reconciles once against the final cart.

     LINE KEYS ARE NOT STABLE. Shopify re-keys a line whenever its discount
     allocation changes - adding the 2nd PeekoraScope switches on "Buy 2 -
     Save 25%" and re-keys the line we are about to remove. Removing by the
     key captured before step 1 fails with "no valid id or line parameter"
     and leaves BOTH colours in the cart (verified 2026-10-14). Step 2 finds
     the old line again by variant id + identical properties.

     Never offered on: the free gift line, the CA$0 gift variant, and the
     fixed 2-pack/3-pack bundle lines (their colours are set as a set).
     ---------------------------------------------------------------------- */
  var productCache = {};
  function loadProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch(BASE + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (response) { return response.ok ? response.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }

  var SWATCHES = { white:'#ffffff', yellow:'#ffd23f', pink:'#f7a1c4', purple:'#9b7bd4', blue:'#5aa9e6', green:'#58b368', orange:'#f59e42', red:'#e5534b', black:'#1f2933' };
  function swatchFor(title) {
    var words = String(title || '').toLowerCase().match(/[a-z]+/g) || [];
    for (var i = 0; i < words.length; i += 1) {
      if (SWATCHES[words[i]]) return SWATCHES[words[i]];
    }
    return '';
  }
  function swatchHtml(title) {
    var color = swatchFor(title);
    return color ? '<i class="pkmc__swatch" style="background:' + color + '" aria-hidden="true"></i>' : '';
  }

  function canSwitch(item) {
    if (!item || isGift(item) || isOfficialScopeBundle(item)) return false;
    if (item.sku === GIFT_SKU || Number(item.original_price || item.price || 0) <= 0) return false;
    return Boolean(item.variant_title) && item.variant_title !== 'Default Title' && !item.product_has_only_default_variant;
  }

  function switchableVariants(product) {
    return ((product && product.variants) || []).filter(function (variant) {
      return Number(variant.price) > 0 && variant.sku !== GIFT_SKU;
    });
  }

  function sameProps(a, b) {
    return JSON.stringify(a || {}) === JSON.stringify(b || {});
  }

  function closePickers(except) {
    root.querySelectorAll('[data-pkmc-vpick]').forEach(function (pick) {
      if (pick === except) return;
      pick.hidden = true;
      var button = pick.previousElementSibling;
      if (button && button.hasAttribute('data-pkmc-variant-edit')) button.setAttribute('aria-expanded', 'false');
    });
  }

  function toggleVariantPicker(button) {
    var pick = button.nextElementSibling;
    if (!pick || !pick.hasAttribute('data-pkmc-vpick')) return;
    if (!pick.hidden) {
      pick.hidden = true;
      button.setAttribute('aria-expanded', 'false');
      return;
    }
    var item = findItem(button.getAttribute('data-key'));
    if (!item) { refresh(); return; }
    closePickers(pick);
    pick.hidden = false;
    button.setAttribute('aria-expanded', 'true');
    pick.innerHTML = '<span class="pkmc__vpick-msg">' + (FR ? 'Chargement des options…' : 'Loading options…') + '</span>';
    loadProduct(item.handle).then(function (product) {
      var variants = switchableVariants(product);
      if (variants.length < 2) {
        pick.innerHTML = '';
        pick.hidden = true;
        button.setAttribute('aria-expanded', 'false');
        return;
      }
      var samePrice = variants.every(function (variant) { return Number(variant.price) === Number(variants[0].price); });
      var key = escapeHtml(item.key);
      pick.innerHTML = variants.map(function (variant) {
        var current = Number(variant.id) === Number(item.variant_id);
        var soldOut = !variant.available;
        return '<button type="button" class="pkmc__vchip' + (current ? ' is-on' : '') + '" data-pkmc-vchoice="' + escapeHtml(variant.id) + '" data-key="' + key + '" aria-pressed="' + current + '"' + (soldOut && !current ? ' disabled' : '') + '>' +
          swatchHtml(variant.title) + '<span>' + escapeHtml(variant.title) + '</span>' +
          (samePrice ? '' : '<b>' + formatMoney(variant.price) + '</b>') +
          (soldOut ? '<b>' + (FR ? 'Épuisé' : 'Sold out') + '</b>' : '') +
        '</button>';
      }).join('') + '<p class="pkmc__vpick-msg" data-pkmc-vpick-status role="status" aria-live="polite"></p>';
    });
  }

  function swapVariant(chip) {
    if (mutating) return;
    var key = chip.getAttribute('data-key');
    var item = findItem(key);
    var newId = Number(chip.getAttribute('data-pkmc-vchoice'));
    var pick = chip.closest('[data-pkmc-vpick]');
    if (!item) { refresh(); return; }
    if (newId === Number(item.variant_id)) {
      if (pick) { pick.hidden = true; if (pick.previousElementSibling) pick.previousElementSibling.setAttribute('aria-expanded', 'false'); }
      return;
    }
    mutating = true;
    root.classList.add('is-updating');
    chip.classList.add('is-busy');
    var properties = item.properties && typeof item.properties === 'object' ? item.properties : {};
    var oldVariantId = Number(item.variant_id);
    var swapQty = Number(item.quantity) || 1;
    var jsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };
    fetch(BASE + 'cart/add.js', {
      method: 'POST',
      headers: jsonHeaders,
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: newId, quantity: swapQty, properties: properties }] })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (data) {
          throw new Error(data.description || (FR ? 'Cette option n’est pas disponible.' : 'That option is not available right now.'));
        });
      }
      return fetch(BASE + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); });
    }).then(function (cart) {
      var oldLine = null;
      (cart.items || []).forEach(function (line) {
        if (!oldLine && Number(line.variant_id) === oldVariantId && sameProps(line.properties, properties)) oldLine = line;
      });
      if (!oldLine) return cart;
      return fetch(BASE + 'cart/change.js', {
        method: 'POST',
        headers: jsonHeaders,
        credentials: 'same-origin',
        body: JSON.stringify({ id: oldLine.key, quantity: Math.max(0, Number(oldLine.quantity) - swapQty) })
      }).then(function (response) {
        if (!response.ok) throw new Error(FR ? 'Impossible de mettre à jour le panier.' : 'Unable to update the cart.');
        return response.json();
      });
    }).then(function (cart) {
      render(cart);
      document.dispatchEvent(new CustomEvent('peekora:cart:changed', { detail: { cart: cart } }));
    }).catch(function (error) {
      var status = pick && pick.querySelector('[data-pkmc-vpick-status]');
      if (status) status.textContent = error.message;
      chip.classList.remove('is-busy');
      refresh();
    }).finally(function () {
      mutating = false;
      root.classList.remove('is-updating');
    });
  }

  /* FIX (2026-07-26): every control now carries the Shopify LINE ITEM KEY
     instead of a positional line number. The gift engine adds and removes the
     MiniScope line asynchronously (~140ms after any cart change), which
     reshuffles line numbers underneath the rendered drawer. A customer who
     tapped minus or Remove during that window was sending a stale line number
     to /cart/change.js and silently editing THE WRONG PRODUCT - the classic
     "I removed one thing and something else disappeared" report. Keys are
     stable identifiers, so a stale click now targets the intended line or
     harmlessly no-ops. */
  function itemMarkup(item) {
    var gift = isGift(item);
    var key = escapeHtml(item.key);
    var original = Number(item.original_line_price || item.final_line_price || 0);
    var finalPrice = Number(item.final_line_price || 0);
    var image = item.image ? '<a class="pkmc__image" href="' + escapeHtml(item.url) + '"><img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy"></a>' : '<span class="pkmc__image"></span>';
    var hasVariant = item.variant_title && item.variant_title !== 'Default Title';
    var variant = '';
    if (hasVariant && canSwitch(item)) {
      variant = '<button type="button" class="pkmc__vbtn" data-pkmc-variant-edit data-key="' + key + '" aria-expanded="false" aria-label="' + escapeHtml((FR ? 'Changer l’option : ' : 'Change option: ') + item.variant_title) + '">' +
        swatchHtml(item.variant_title) + '<span>' + escapeHtml(item.variant_title) + '</span>' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg></button>' +
        '<div class="pkmc__vpick" data-pkmc-vpick hidden></div>';
    } else if (hasVariant) {
      variant = '<span class="pkmc__variant">' + escapeHtml(item.variant_title) + '</span>';
    }
    var badges = gift ? '<span class="pkmc__badge">FREE GIFT</span>' : '';
    var discounts = lineDiscounts(item);
    var qty = gift ? '<span class="pkmc__variant">Included with your offer</span>' :
      '<div class="pkmc__qty"><button type="button" data-pkmc-minus data-key="' + key + '" aria-label="Decrease quantity">−</button><span>' + item.quantity + '</span><button type="button" data-pkmc-plus data-key="' + key + '" aria-label="Increase quantity">+</button></div>';
    var oldPrice = original > finalPrice ? '<s>' + formatMoney(original) + '</s>' : '';
    var price = gift && finalPrice === 0 ? '<strong class="is-free">FREE GIFT</strong>' : '<strong>' + formatMoney(finalPrice) + '</strong>';
    /* The gift is granted and revoked automatically by the tier rules. Offering
       a Remove button on it invited a fight the customer could not win: they
       removed it, the reconciler re-added it a moment later, and the drawer
       looked haunted. */
    var removeButton = gift ? '' : '<button class="pkmc__remove" type="button" data-pkmc-remove data-key="' + key + '">Remove</button>';
    var includedGift = isOfficialScopeBundle(item) ? '<div class="pkmc__included-gift"><img src="https://cdn.shopify.com/s/files/1/0719/2304/0335/files/peekora-miniscope-white.png?v=1786146740" alt="" width="40" height="40"><span><strong>FREE Peekora MiniScope™</strong><small>FREE GIFT · Included with your bundle</small></span></div>' : '';

    return '<article class="pkmc__item' + (gift ? ' is-gift' : '') + '" data-pk-key="' + key + '">' +
      image +
      '<div class="pkmc__meta">' +
        badges +
        '<a class="pkmc__title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' +
        variant +
        (isOfficialScopeBundle(item) ? '<div class="pkmc__bundle-breakdown"><strong>Bundle includes</strong><div style="display:grid;gap:7px;margin-top:7px">' + String(item.variant_title || '').split(' / ').map(function(color,index){return '<div style="display:flex;align-items:center;gap:9px;padding:7px;border-radius:10px;background:#f7f9fb"><img src="'+escapeHtml(({white:'https://cdn.shopify.com/s/files/1/0719/2304/0335/files/peekora-scope-rock-closeup.png?v=1783817405',yellow:'https://cdn.shopify.com/s/files/1/0719/2304/0335/files/ImageJul1_2026_02_29_57PM.png?v=1783816539',pink:'https://cdn.shopify.com/s/files/1/0719/2304/0335/files/peekora-scope-fabric-threads.png?v=1783817405',purple:'https://cdn.shopify.com/s/files/1/0719/2304/0335/files/peekora-scope-flower-detail.png?v=1783817405'}[color.trim().toLowerCase()]||'https://cdn.shopify.com/s/files/1/0719/2304/0335/files/PeekoraScope_Explorer_4K_Kids_Discovery_Microscope_3.png?v=1786305285'))+'" alt="" width="42" height="42" style="width:42px;height:42px;object-fit:cover;border-radius:9px;background:#fff"><span><strong style="display:block">Microscope '+(index+1)+'</strong><small style="display:block">'+escapeHtml(color.trim())+'</small></span></div>';}).join('') + '</div></div>' : '') + includedGift +
        (discounts ? '<div class="pkmc__discounts">' + discounts + '</div>' : '') +
        '<div class="pkmc__item-bottom">' +
          qty +
          '<div><div class="pkmc__line-price">' + oldPrice + price + '</div>' + removeButton + '</div>' +
        '</div>' +
      '</div>' +
    '</article>';
  }

  function officialBundleRegularTotal(item) {
    var props=item.properties||{};
    var explicit=Number(props._peekora_regular_total_cents||0);
    if(explicit>0)return explicit*Number(item.quantity||1);
    var title=String(item.product_title||'').toLowerCase();
    var finalPrice=Number(item.final_line_price||0);
    if(String(props._peekora_bundle_qty||'')==='2'||title.indexOf('2-pack')!==-1)return Math.round(finalPrice*4/3);
    if(String(props._peekora_bundle_qty||'')==='3'||title.indexOf('3-pack')!==-1)return Math.round(finalPrice*3/2);
    return Number(item.original_line_price||finalPrice);
  }

  function updateHeaderCounts(count) {
    document.querySelectorAll('[data-cart-count], .cart-count, .header-cart-count').forEach(function (element) {
      element.textContent = count;
      element.hidden = count < 1;
    });
  }


  /* 2026-10-14: the old "Add another discovery & save" block was removed from
     this file (it was only hidden by CSS, so shoppers whose stylesheet loaded
     late still saw it), and its 10% discount was switched off. The "You might
     also like" rail (pk-cart-nike.js) is the only cross-sell now; each card
     carries a deal tag, and this one-line note under the heading explains
     them: every product deal needs 2 of the same item.
     The style block also carries the colour/option switcher styles. */
  var layoutStyle = document.createElement('style');
  layoutStyle.textContent = '#PeekoraMiniCart[data-pkmc-complete-set-only="true"] [data-pkmc-bundle-progress]{display:none!important}#PeekoraMiniCart [data-xs-rec]{display:none!important}#PeekoraMiniCart [data-pkmc-items]{order:0!important}#PeekoraMiniCart [data-pkmc-offer]{order:10!important}#PeekoraMiniCart [data-pkmc-bundle-progress]{order:11!important}#PeekoraMiniCart #pk-xs{order:20!important}' +
    '#PeekoraMiniCart .pkmc__vbtn{display:inline-flex;align-items:center;gap:6px;max-width:100%;min-height:34px;margin-top:6px;padding:4px 10px 4px 11px;border:1px solid #d6e0de;border-radius:999px;background:#fff;color:#102d38;font:700 13px/1.2 Nunito,system-ui,sans-serif;cursor:pointer;-webkit-tap-highlight-color:transparent}' +
    '#PeekoraMiniCart .pkmc__vbtn span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}' +
    '#PeekoraMiniCart .pkmc__vbtn:hover{border-color:#102d38}' +
    '#PeekoraMiniCart .pkmc__vbtn svg{flex:0 0 14px;width:14px;height:14px;fill:none;stroke:currentColor;stroke-width:2.4;stroke-linecap:round;stroke-linejoin:round;transition:transform .2s ease}' +
    '#PeekoraMiniCart .pkmc__vbtn[aria-expanded="true"]{border-color:#102d38}' +
    '#PeekoraMiniCart .pkmc__vbtn[aria-expanded="true"] svg{transform:rotate(180deg)}' +
    '#PeekoraMiniCart .pkmc__swatch{flex:0 0 14px;display:inline-block;width:14px;height:14px;border-radius:50%;box-shadow:inset 0 0 0 1px rgba(16,45,56,.22)}' +
    '#PeekoraMiniCart .pkmc__vpick{display:flex;flex-wrap:wrap;gap:6px;margin-top:8px}' +
    '#PeekoraMiniCart .pkmc__vpick[hidden]{display:none}' +
    '#PeekoraMiniCart .pkmc__vchip{display:inline-flex;align-items:center;gap:6px;min-height:38px;padding:6px 12px;border:1.5px solid #d6e0de;border-radius:999px;background:#fff;color:#102d38;font:700 13px/1.2 Nunito,system-ui,sans-serif;cursor:pointer;-webkit-tap-highlight-color:transparent}' +
    '#PeekoraMiniCart .pkmc__vchip:hover{border-color:#102d38}' +
    '#PeekoraMiniCart .pkmc__vchip.is-on{border-color:#102d38;box-shadow:inset 0 0 0 1px #102d38;background:#f4f7f6}' +
    '#PeekoraMiniCart .pkmc__vchip b{color:#607078;font-weight:700}' +
    '#PeekoraMiniCart .pkmc__vchip:disabled{opacity:.45;cursor:not-allowed}' +
    '#PeekoraMiniCart .pkmc__vchip:disabled span{text-decoration:line-through}' +
    '#PeekoraMiniCart .pkmc__vchip.is-busy{opacity:.6}' +
    '#PeekoraMiniCart .pkmc__vpick-msg{flex:1 0 100%;margin:0;color:#607078;font-size:12px}' +
    '#PeekoraMiniCart .pkmc__vpick-msg:empty{display:none}';
  root.appendChild(layoutStyle);

  function recsNote(cart) {
    var head = root.querySelector('.pkn-recs__head');
    if (!head) return;
    var note = root.querySelector('[data-pkmc-recs-note]');
    if (!note) {
      note = document.createElement('p');
      note.setAttribute('data-pkmc-recs-note', '');
      note.style.cssText = 'margin:-6px 16px 12px;color:#6B6B6B;font-size:13px;font-weight:600;line-height:1.4';
      note.textContent = FR ? 'Les offres s’appliquent automatiquement quand vous prenez 2 du même article.' : 'Deals apply automatically when you buy 2 of the same item.';
      head.insertAdjacentElement('afterend', note);
    }
    note.hidden = !(cart && cart.items && cart.items.length);
  }

  function render(cart) {
    currentCart = cart;
    var hasCompleteSet=(cart.items||[]).some(function(i){return Number(i.variant_id)===46166600089679;});
    var hasSingleBook=(cart.items||[]).some(function(i){return i.handle==='peekora-magicreveal-water-coloring-book'&&Number(i.variant_id)!==46166600089679;});
    var hasScope=(cart.items||[]).some(function(i){return /peekorascope/i.test(i.product_title||'');});
    root.setAttribute('data-pkmc-complete-set-only',hasCompleteSet&&!hasSingleBook&&!hasScope?'true':'false');
    recsNote(cart);
    loadingEl.hidden = true;
    countEl.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    updateHeaderCounts(cart.item_count || 0);

    if (!cart.items || !cart.items.length) {
      itemsEl.innerHTML = '';
      emptyEl.hidden = false;
      footerEl.hidden = true;
      return;
    }

    emptyEl.hidden = true;
    footerEl.hidden = false;
    var displayItems=cart.items.slice().sort(function(a,b){function rank(item){if(item.sku==='PEEKORA-MINISCOPE-FREE-GIFT'||Number(item.final_line_price)===0)return 2;return ['32-gb-sd-card','magicreveal-water-brush'].indexOf(item.handle)>-1?1:0;}return rank(a)-rank(b);});
    itemsEl.innerHTML = displayItems.map(itemMarkup).join('');

    /* The footer is hidden until the first non-empty render, so the wallet
       buttons cannot measure anything before this point. Covers the shopper
       whose first drawer view was an empty cart. */
    layoutWallets();

    var regularFromLines=(cart.items||[]).reduce(function(total,item){return total+officialBundleRegularTotal(item);},0);
    var regular=Math.max(regularFromLines,Number(cart.original_total_price||0),Number(cart.total_price||0)+Number(cart.total_discount||0));
    var savings=Math.max(regular-Number(cart.total_price||0),Number(cart.total_discount||0));
    subtotalEl.textContent = formatMoney(cart.total_price);

    if (regular > cart.total_price) {
      regularRow.hidden = false;
      regularEl.textContent = formatMoney(regular);
    } else {
      regularRow.hidden = true;
    }

    if (savings > 0) {
      savingRow.hidden = false;
      savingEl.textContent = '−' + formatMoney(savings);
    } else {
      savingRow.hidden = true;
    }
  }

  function refresh() {
    loadingEl.hidden = false;
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to load cart');
        return response.json();
      })
      .then(function (cart) {
        render(cart);
        return cart;
      })
      .catch(function () {
        loadingEl.textContent = 'Unable to update the cart. Please refresh the page.';
      });
  }

  function open() {
    lastFocus = document.activeElement;
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    lockScroll();
    // A forced reflow, not requestAnimationFrame: rAF never fires in a
    // background tab, which would leave the drawer un-hidden but untransformed
    // — an invisible layer covering the page.
    void root.offsetWidth;
    // The drawer now has real layout width, so the wallet buttons can finally
    // measure a container and choose the horizontal row.
    layoutWallets();
    root.classList.add('is-open');
    /* Re-opening after an add-to-cart should show the customer the top of their
       cart, not wherever they had scrolled to on the previous visit. */
    if (bodyEl) bodyEl.scrollTop = 0;
    var closeButton = root.querySelector('[data-pkmc-close]');
    if (closeButton) closeButton.focus();
    return refresh();
  }

  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    unlockScroll();
    setTimeout(function () {
      root.hidden = true;
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }, 260);
  }

  function changeLine(key, quantity) {
    mutating = true;
    root.classList.add('is-updating');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json','Accept':'application/json'},
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to update item');
      return response.json();
    }).then(function (cart) {
      render(cart);
      document.dispatchEvent(new CustomEvent('peekora:cart:changed', { detail: { cart: cart } }));
    }).catch(function () {
      return refresh();
    }).finally(function () {
      mutating = false;
      root.classList.remove('is-updating');
    });
  }

  root.addEventListener('click', function (event) {
    if (event.target.closest('[data-pkmc-close]')) {
      close();
      return;
    }

    var variantEdit = event.target.closest('[data-pkmc-variant-edit]');
    if (variantEdit) {
      toggleVariantPicker(variantEdit);
      return;
    }
    var variantChoice = event.target.closest('[data-pkmc-vchoice]');
    if (variantChoice) {
      if (!variantChoice.disabled) swapVariant(variantChoice);
      return;
    }

    var plus = event.target.closest('[data-pkmc-plus]');
    var minus = event.target.closest('[data-pkmc-minus]');
    var remove = event.target.closest('[data-pkmc-remove]');
    if (plus || minus || remove) {
      /* Ignore taps that land while a previous change is still in flight -
         otherwise the second tap computes its new quantity from a cart object
         that is already out of date and overwrites the first change. */
      if (mutating) return;
      var control = plus || minus || remove;
      var key = control.getAttribute('data-key');
      var item = findItem(key);
      if (!item) { refresh(); return; }
      var quantity = remove ? 0 : item.quantity + (plus ? 1 : -1);
      changeLine(key, quantity);
    }

    if (event.target.closest('[data-pkmc-apply]')) {
      if (!getCode()) {
        if (codeInput) codeInput.focus();
        return;
      }
      saveCode();
      unlockScroll();
      location.assign(discountUrl(location.pathname + location.search));
    }

    if (event.target.closest('[data-pkmc-checkout]')) {
      /* Do not hand the customer to checkout while the tier reconciler may still
         be adding or removing the gift line - the checkout would be built from a
         cart the customer never saw. */
      if (mutating) return;
      saveCode();
      /* Release the body lock before navigating. A bfcache restore (iOS back
         button from checkout) can otherwise return the shopper to a page whose
         <body> is still position:fixed and apparently frozen. */
      unlockScroll();
      location.assign(getCode() ? discountUrl('/checkout') : '/checkout');
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !root.hidden) close();
  });

  /* Same bfcache concern as above: if the page is restored from history with the
     drawer still open, drop the lock so the store is scrollable again. */
  window.addEventListener('pageshow', function (event) {
    if (event.persisted && !root.hidden) close();
  });

  document.addEventListener('click', function (event) {
    var cartLink = event.target.closest('a[href="/cart"], a[href$="/cart"]');
    if (!cartLink || location.pathname === '/cart' || cartLink.closest('.pkmc')) return;
    event.preventDefault();
    open();
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || event.defaultPrevented) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1 || form.hasAttribute('data-no-mini-cart')) return;

    event.preventDefault();
    var submitter = event.submitter;
    if (submitter) submitter.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      body: new FormData(form)
    }).then(function (response) {
      if (!response.ok) return response.json().then(function (data) { throw new Error(data.description || 'Unable to add item'); });
      return response.json();
    }).then(function () {
      return open();
    }).catch(function (error) {
      alert(error.message);
    }).finally(function () {
      if (submitter) submitter.disabled = false;
    });
  });

  document.addEventListener('peekora:cart:updated', function (event) {
    var shouldOpen = !event.detail || event.detail.open !== false;
    if (shouldOpen) open();
    else refresh();
  });

  if (codeInput) {
    try {
      var stored = sessionStorage.getItem('pq-discount-code');
      if (stored) codeInput.value = stored;
    } catch (error) {}
    codeInput.addEventListener('input', function () {
      codeInput.value = codeInput.value.toUpperCase();
      saveCode();
    });
    codeInput.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        if (getCode()) {
          unlockScroll();
          location.assign(discountUrl(location.pathname + location.search));
        }
      }
    });
  }

  window.PeekoraMiniCart = { open: open, close: close, refresh: refresh };
})();
